import type { CalendarEntry, CalendarGroup } from 'owa-graph-schema';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * The action creates a new calendar under the provided group with the name provided.
 */
export const createCalendar = action(
    'createCalendar',
    (
        userIdentity: string,
        calendarName: string,
        calendarGroup: CalendarGroup,
        onCalendarCreated?: (createdCalendar: CalendarEntry | null) => void
    ) =>
        addDatapointConfig(
            {
                name: 'CalendarCreated',
                options: {
                    isCore: true,
                },
                customData: {
                    source_1: 'CalendarPicker',
                },
            },
            {
                userIdentity,
                calendarName,
                calendarGroup,
                onCalendarCreated,
            }
        )
);

/**
 * The action first confirms from user whether they want to delete the calendar group.
 * If they do then it deletes the calendar group.
 */
export const confirmAndDeleteCalendarGroup = action(
    'confirmAndDeleteCalendarGroup',
    (
        userIdentity: string,
        calendarGroup: CalendarGroup,
        onDelete?: (isDeleted: boolean) => void
    ) => ({
        userIdentity,
        calendarGroup,
        onDelete,
    })
);

/**
 * The action creates a new calendar group
 */
export const createCalendarGroup = action(
    'createCalendarGroup',
    (scenarioId: CalendarPickerScenarioId, userIdentity: string, calendarGroupName: string) => ({
        scenarioId,
        userIdentity,
        calendarGroupName,
    })
);

/**
 * The action to create group
 */
export const createGroup = action('createGroup', () => ({}));
